import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import CrewTable from "../../components/table/CrewTable/crew-table";
import CustomLink from "../../components/UI/customLink/customLink";
import { useTranslation } from "react-i18next";
import {ArrowLeftIcon, BluePlusIcon, Close, PlusIcon} from "../../icons/icons";
import CustomInput from "../../components/UI/customInput/customInput";
import CustomButton from "../../components/UI/customButton/customButton";
import {useSelector} from "react-redux";

const Crew = () => {
  const [idModal, setIdModal] = useState(false);
  const [crewList, setCrewList] = useState([]);
  const navigate = useNavigate(); // Initialize navigate
  const user = useSelector((state) => state.user.user)

  const isCrewAgent = user?.role_key?.toLowerCase() == "CrewAgent"?.toLowerCase()


  const handleCrewList = (e) => {
    const newList = [...crewList]; // Create a new array
    const find = newList.findIndex((item) => item === e);
    if (find !== -1) {
      newList.splice(find, 1);
    } else {
      newList.push(e);
    }
    setCrewList(newList);
  };

  const { t } = useTranslation();


  return (
    <div className={"mb-10"}>
      <div className={"my-container rounded-lg flex justify-between items-center w-full"}>
        <div className={"w-[207px]"}>
          <CustomLink icon={<BluePlusIcon/>} typeTwo link={"/crew/single?mode=add"} title={t("newCrew")} />
        </div>
        {
          user?.role_key !== "super_admin" && !isCrewAgent && 
          <div className={"w-[207px]"}>
            <CustomButton icon={<ArrowLeftIcon/>} onClick={() => setIdModal(true)} title={t("visaRequest")} />
          </div>
        }

      </div>
      <CrewTable onChange={(e) => handleCrewList(e)} defaultValue={crewList}/>
      {
        user?.role_key !== "super_admin" &&
        <div onClick={(e) => e.target === e.currentTarget && setIdModal(false)} className={`${idModal ? "flex" : "hidden"} bg-modal h-full w-full fixed top-0 right-0 z-30 items-center justify-center`}>
          <div className={"bg-white rounded-2xl p-5 w-[350px]"}>
            <div className={"flex items-center mb-8 justify-between"}>
            <span className={'text-primary-400 text-base'}>
              {t("visaRequest")}
            </span>
              <span onClick={() => setIdModal(false)} className={"cursor-pointer"}>
              <Close color={"#8A9098"} />
            </span>
            </div>
            <div className={'text-primary-400 text-lg mb-4 text-center font-light'}>
              {crewList.length + t("visaRequestTitle")}
            </div>
            <div className={'text-lg mb-6 text-center text-sm text-gray-500 font-medium'}>
              {t("visaRequestTitleDes")}
            </div>
            <div className="relative bg-white rounded-lg flex flex-col items-center w-full overflow-hidden">
              <div className={"flex flex-col gap-5 w-full"}>
                <div className={"w-full"}>
                  {/* Update the button to navigate with crewList */}
                  <CustomButton
                    onClick={() => {
                      navigate('/visa-orders/new-visa', { state: { crewList } }); // Navigate and pass crewList
                    }}
                    styles={"text-sm"}
                    title={t("understand")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

      }
    </div>
  );
};

export default Crew;
